import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { WINDOW } from '../../window.provider';
import { share } from 'rxjs/operators';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatSelect } from '@angular/material/select';
import { OverlayContainer } from '@angular/cdk/overlay';
import { BackendService } from './backend-prod.service';
import { resolve } from 'dns';
import { Fernet  } from 'fernet-ts';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  toast: HTMLIonToastElement;
  [x: string]: any;
  private objectFromStorageSource = new BehaviorSubject<Object>({});
  public navhelp: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public fromPageRoot: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public objectFromStorage$ = this.objectFromStorageSource.asObservable();
  public navhelp$ = this.navhelp.asObservable();
  public fromPageRoot$ = this.fromPageRoot.asObservable();
  public sourceAPI = "/RestAPIsource/app";
  public targetAPI = "/RestAPIops/app";
  private onSubject = new Subject<{ key: string, value: any }>();
  public changes = this.onSubject.asObservable().pipe(share());

  public visualizationAcces: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public visualizationAcces$ = this.visualizationAcces.asObservable();

  public goldfinchAcces: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public goldfinchAcces$ = this.goldfinchAcces.asObservable();

  public consoleData: BehaviorSubject<[]> = new BehaviorSubject([]);
  public consoleData$ = this.consoleData.asObservable();

  private parentNavigationHelpTrigger = new Subject<any>();
  private childNavigationHelpTrigger = new Subject<any>();
  parentNavigationHelpFunction$ = this.parentNavigationHelpTrigger.asObservable();
  childNavigationHelpFunction$ = this.childNavigationHelpTrigger.asObservable();

  private sourcePostmanPreviewTrigger = new Subject<any>();
  private targetPostmanPreviewTrigger = new Subject<any>();
  sourcePostmanPreviewFunction$ = this.sourcePostmanPreviewTrigger.asObservable();
  targetPostmanPreviewFunction$ = this.targetPostmanPreviewTrigger.asObservable();

  public jobTitle = [
    { id: '1', name: 'CXO/General Manager' },
    { id: '2', name: 'IT Manager' },
    { id: '3', name: 'Operations Manager' },
    { id: '4', name: 'Consultant' },
    { id: '5', name: 'Developer/Software Engineer/Analyst' },
    { id: '6', name: 'Student/Personal Interest' },
    { id: '7', name: 'Others' }];
  public employee = [
    { id: '1', name: '1 - 15 Employees' },
    { id: '2', name: '15 - 100 Employees' },
    { id: '3', name: '101 - 500 Employees' },
    { id: '4', name: '501 - 1500 Employees' },
    { id: '5', name: '1500+ Employees' }];

  inputString: string;
  outputString: string;
  isGenerateNewTokken: boolean = false;
  roleId: number;
  freeTrialMode: boolean = false;
  fromPage: string = '';
  newConversationName = '';
  isUpdatConversationName: boolean = false;
  isConsoleClear: boolean = false;
  csrf_token = '';
  private renderer: Renderer2 | null = null;
  private scrollDropdownListener: () => void;
  private clickDropdownListener: () => void;

  constructor(
    public toastController: ToastController,
    public loadingController: LoadingController,
    public storage: Storage,
    public alertController: AlertController,
    private backendService:BackendService,
    private overlayContainer: OverlayContainer,
    private rendererFactory: RendererFactory2,
    @Inject(WINDOW) private window: Window
  ) {
    this.start();
  }

  private initializeRenderer(): void {
    if (!this.renderer) {
      this.renderer = this.rendererFactory.createRenderer(null, null);
    }
  }
  navigateFromPilot:boolean=false;

  public getStorage() {
    let status = JSON.parse(localStorage.getItem("status"));
    return status;
  }

  

  public store(key: string, data: any) {
    let s = JSON.parse(localStorage.getItem("status"));
    if (s != null && s.length != 0) {
      if (s.length >= 1) {
        let found = false;
        for (let i in s) {
          if (s[i].id == data.id) {
            found = true;
            s[i].status = data.status
          }
        }
        if (!found) {
          s.push(data);
        }
        localStorage.setItem(key, JSON.stringify(s));
      }
    } else {
      let arr = [];
      arr.push(data);
      localStorage.setItem(key, JSON.stringify(arr));
    }
    this.onSubject.next({ key: key, value: data });
  }

  public async clear(key) {
    let s = JSON.parse(localStorage.getItem("status"));
    if (s.length > 0) {
      let arr = [];
      for (let i in s) {
        if (s[i].id != key) {
          arr.push(s[i]);
        }
      }
      localStorage.setItem("status", JSON.stringify(arr));
    }
    localStorage.removeItem(key);
    this.onSubject.next({ key: key, value: null });
  }


  private start(): void {
    window.addEventListener("storage", this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent) {
    if (event.storageArea == localStorage) {
      let v;
      try { v = JSON.parse(event.newValue); }
      catch (e) { v = event.newValue; }
      this.onSubject.next({ key: event.key, value: v });
    }
  }

  public stop(): void {
    window.removeEventListener("storage", this.storageEventListener.bind(this));
    this.onSubject.complete();
  }

  getUrl(): string {
    return this.window.location.href;
  }

  dataFromStorage(value: Object) {
    this.objectFromStorageSource.next(value);
  }

  generateRandomId(size) {
    const nums = Array.from({ length: 10 }, (_, i) =>
      String.fromCharCode('0'.charCodeAt(0) + i)
    );
    const alphabets = Array.from({ length: 26 }, (_, i) =>
      String.fromCharCode('a'.charCodeAt(0) + i)
    );
    const chars = [...nums, ...alphabets];
    const rand = (length) => Math.floor(Math.random() * length);
    return Array.from({ length: size }, () => chars[rand(chars.length)]).join(
      ''
    );
  }

  sortArr(arr, key) {
    arr.sort((a, b) => {
      if (a[key].toLowerCase() < b[key].toLowerCase()) { return -1; }
      else if (a[key].toLowerCase() > b[key].toLowerCase()) { return 1; }
      return 0;
    })
    return arr;
  }

  sortArrayWithAnotherArray(originalArray, sortArray, key) {
    return [...originalArray].sort(
      (a, b) => sortArray.indexOf(a[key]) - sortArray.indexOf(b[key])
    )
  }

  async presentAlert(header, msg) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
      ],
    });
    await alert.present();
  }


  async presentToastWithButton(message:string) {
    if(this.toast){
      this.dismissToast()
    }
    this.toast = await this.toastController.create({
      message: message,
      buttons: [
        {
          
          role: 'cancel',
          icon: 'close-outline',
          handler: () => {
            this.dismissToast();
          }
        
        }
      ],
      
    });
    this.toast.present();
  }

  
  dismissToast() {
    if (this.toast) {
      this.toast.dismiss();
      this.toast = null;
    }
  }

  
 
 

  async presentToast(msg: string, d: number) {
    const toast = await this.toastController.create({
      message: msg,
      duration: d,
    });
    toast.present();
  }
loading:any=null;
  async loader() {
    if(!this.loading){
      let LoaderConfig = {
        message: "Please wait...",
        // dismissOnPageChange: true,
      };
      this.loading = await this.loadingController.create(LoaderConfig);
      await this.loading.present();
    }
  }
  async closeLoader() {
    if (this.loading) {
      try {
        await this.loading.dismiss();
      } catch (err) {
      }
      this.loading = null;
    }
    // await this.loadingController.dismiss();
    // Instead of directly closing the loader like below line
    // return await this.loadingController.dismiss();
    // this.checkAndCloseLoader();
    // // sometimes there's delay in finding the loader. so check if the loader is closed after one second. if not closed proceed to close again
    // setTimeout(() => this.checkAndCloseLoader(), 30000);
  }

  // async checkAndCloseLoader() {
  //   // Use getTop function to find the loader and dismiss only if loader is present.
  //   const loader = await this.loadingController.getTop();
  //   // if loader present then dismiss
  //   if (loader !== undefined) {
  //     await this.loadingController.dismiss();
  //   }
  // }

  async removeSourceTargetTag(arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == 'source') {
        arr.splice(i, 1);
      }
      if (arr[i] == 'target') {
        arr.splice(i, 1);
      }
    }
  }

  isJsonString(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return false;
      str = JSON.stringify(str);
      return str.replace(/\\/g, '');
    }
  }

  isString(str) {
    let temString = str;
    let finalstr = "";
    // //console.log(str);
    if (str.startsWith("\"")) {
      return this.isJsonString(str);
    }
    str = str.replaceAll(/\\n/g, '\n').replaceAll(/\\\n/g, '\\n');
    // if(str.includes("\"")){
    //   return str.replaceAll(/\\"/g,"\"");
    // }
    return str;
  }

  stringToObjectConverter(type, str, operation?) {
    // var str = str.replaceAll('\n','');
    if (typeof str === 'object' && str !== null) {
      str = JSON.stringify(str);
    } else if (typeof str !== 'string') {
      throw new Error('Input is not a valid string');
    }
    if (operation == "strip") {
      if (str.includes("\\")) {
        // str.replace(/\\/g, "");
        str = JSON.stringify(str).replace(new RegExp(`\\\\\\\\`, "g"), '\\');
        str = JSON.parse(str);
      }
    } else {
      str = str.replaceAll('\n', '');
    }
    var finalstr;
    if (type == 'Array') {
      if (str.substring(0, 1) == '[') {
        let tempstr1 = str.replace('[', '');
        let tempstr2 = tempstr1.replace(']', '');
        let tempstr3 = tempstr2.replace(/"/g, '');
        let temparry = tempstr3.split(',');
        finalstr = temparry;
      }
      if (operation == "strip_Substitute") {
        let tempstr3;
        let regex = /"([^"]*)"|'([^']*)'|""|''/g;
        let matches = [];
        let match;
        while ((match = regex.exec(str)) !== null) {
          if (match[1]!=undefined) {
            matches.push(match[1]);
          }
          if (match[2]!=undefined) {
            matches.push(match[2]);
          }
        }
        finalstr = matches;
      }  else {
      
        let tempstr = str.replace(/"/g, '');
        let temparry = tempstr.split(",");
        temparry = temparry.map(item=>item.includes(' ')?item.trim():item)
        finalstr = temparry;
      }
    }else if (type == 'Json') { 
      // to handle utf code
      if (operation == 'append') {
          str = str.replace(/\\\\u/g, '?');
          str = str.replace(/\\u/g, '#');
      }
  
      if (str.startsWith('{')) {
          var tempstr = JSON.parse(str);
          finalstr = tempstr;
      } else {
        var getstr = "{" + str + "}";
        try{
          var tempstr = JSON.parse(getstr);
          finalstr = tempstr;
        }catch(e){
          return false
        }
      }
  
      if (operation == 'append') {
          Object.keys(finalstr).forEach((key) => {
              if (typeof finalstr[key] === 'string') {
                  // Restore double-slash Unicode sequences
                  finalstr[key] = finalstr[key].replace(/\?/g, '\\\\u');
                  // Restore single-slash Unicode sequences
                  finalstr[key] = finalstr[key].replace(/\#/g, '\\u');
              }
          });
      }
  
    
    } else if (type == 'String') {
      let tempstr = str.replace(/"/g, "'");
      finalstr = tempstr;
    } else if (type == 'Boolean') {
      let tempstr = JSON.parse(str.toLowerCase());
      finalstr = tempstr;
    } else if (type == 'Number') {
      let tempstr = parseFloat(str);
      finalstr = tempstr;
    }
    return finalstr;
  }
  
objectToStringConverter(type, obj) {
    var finalstr = "";
    if (type == 'Array') {
      if (obj[0] != '[') {
        var temps = "";
        for (var i = 0; i < obj.length; i++) {
          temps += '"' + obj[i] + '"';
          if (i < obj.length - 1) {
            temps += ",";
          }
        }
        finalstr = temps;
      } else {
        finalstr = '[]';
      }

    } else if (type == 'Json') {
      // Temporarily replace double-slash Unicode (`\\u`) and single-slash Unicode (`\u`)
      Object.keys(obj).forEach((key) => {
          if (typeof obj[key] === 'string') {
              // Replace `\\u` with a temporary placeholder
              obj[key] = obj[key].replace(/\\\\u/g, '?');
              // Replace `\u` with a temporary placeholder
              obj[key] = obj[key].replace(/\\u/g, '#');
          }
      });

      // Convert the object to a JSON string
      let tempstr = JSON.stringify(obj);
      let tempobj = tempstr.slice(1, -1); // Remove the outer curly braces

      // Restore the original Unicode sequences
      if (tempobj.includes('?')) {
          tempobj = tempobj.replace(/\?/g, '\\\\u');
      }
      if (tempobj.includes('%')) {
          tempobj = tempobj.replace(/\#/g, '\\u');
      }

      finalstr = tempobj;
  }

  return finalstr;

   
  }


  reloadPage() {
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  navhelpclear(param: boolean) {
    this.navhelp.next(param);
  }

  getNavHelp(): Observable<boolean> {
    return this.navhelp.asObservable();
  }

  getFromPageReset(param: boolean) {
    this.fromPageRoot.next(param);
  }

  getFromPage(): Observable<boolean> {
    return this.fromPageRoot.asObservable();
  }

  visualizationAccesDenied(param: boolean) {
    this.visualizationAcces.next(param);
  }

  getVisualizationAcces(): Observable<boolean> {
    return this.visualizationAcces.asObservable();
  }

  goldfinchAccesDenied(param: boolean) {
    this.goldfinchAcces.next(param);
  }

  getGoldfinchAcces(): Observable<boolean> {
    return this.goldfinchAcces.asObservable();
  }

  shareConsoleData(item: any) {
    this.consoleData.next(item);
  }

  getConsoleData(): Observable<any> {
    return this.consoleData.asObservable();
  }
  // async getStorage () {
  //     let data = {
  //       token: await this.storage.get("token"),
  //       userId: await this.storage.get("id")
  //     }
  //     return data
  // }
  replaceDoubleToSingleBackSlash(str: any) {
    str = JSON.stringify(str).replace(/\\/g, '\\\\');
    str = JSON.parse(str);
    return str
  }

  isValidJSON(obj) {
    try {
      JSON.parse(obj);
      return true;
    } catch (e) {
      return false;
    }
  }

  isValidXML(xmlValue) {
    const parser = new DOMParser();
    const xmlString = xmlValue;
    const doc1 = parser.parseFromString(xmlString, "application/xml");
    const errorNode = doc1.querySelector("parsererror");
    if (errorNode) {
      // parsing failed
      //console.log("Getting Error")
      return false;
    } else {
      // parsing success
      //console.log("No Error")
      return true;
    }
  };

  isValidString(str){
    const checkString = /^\s*"([^\x22']+)"(?:\s*,\s*"([^\x22']+)")*\s*$/;
    try {
      if (checkString.test(str)) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;  
    }
  };
  
  endpointUrl(arr, text) {
    let st = text.split("{{");
    let xx = [];
    let env_var = [];
    for (let i of st) {
      if (i.includes('}}')) {
        env_var.push('{{' + i.split('}}')[0] + '}}');
        xx.push('<span style="color: red">{{' + i.split('}}')[0].replace(/[^a-zA-Z_0-9 -]/g, "") + '}}</span>');
      }
    }

    let regex;
    if (arr.length > 0) {
      for (var i = 0; i < arr.length; i++) {
        if (env_var.includes(arr[i])) {
          for (let j = 0; j < env_var.length; j++) {
            regex = new RegExp(arr[i], "g");
            if (arr[i] == env_var[j]) {
              text = text.replace(regex, xx[j]);
            }
          }
        }
      }
    } else {
      text = text.replace(/<[^>]*>/g, '');
    }
    return text
  }

  validateDataOperation(finalBlockArray) {
    for (let block of finalBlockArray) {
      //console.log("block" + block)
    }
  }
  
  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }
  extractXml(input: any): string {
    if(input.includes("&quot;")){
      input=input.replaceAll("&quot;",'"');
      input=input.replaceAll("&lt;",'<');
      input=input.replaceAll("&gt;",'>');
    }
    var xmlDeclarationEnd = input.indexOf('?-->');
    let xmlContentAfterDeclaration = input.slice(xmlDeclarationEnd + 4).trim();
    if(xmlContentAfterDeclaration.includes('\\n')){
      xmlContentAfterDeclaration = xmlContentAfterDeclaration.replaceAll(
        '\\n',
        ''
      );
    }
    let tagMatch = xmlContentAfterDeclaration.match(/^<(\w+)/);
    let xmlString = input.substring(
      input.indexOf('<!--?xml'),
      input.lastIndexOf(`</${tagMatch[1]}>`) + tagMatch[1].length + 3
    );
    xmlString=xmlString.replaceAll('\\n',"");
    xmlString=xmlString.replaceAll('\\t',"");
    xmlString=xmlString.replaceAll('<!--?xml',"<?xml");
    xmlString=xmlString.replaceAll('?-->',"?>");
    xmlString=xmlString.replace(/\\\\/g, '\\'); 
    xmlString=xmlString.replace(/\\"/g, '"');
    return xmlString.trim();
  }

  decode(token: string): Promise<any> {
    if(token){
      return new Promise((resolve) => {
        Fernet.getInstance(environment.secretKey).then((fernet) => {
          fernet.decrypt(token).then((res) => {
            resolve(this.jwtToJson(res));
          })
        })
      })
    }
  }

  decryptpayload(integration: string): Promise<any> {
    if (integration) {
      return new Promise((resolve, reject) => {
        Fernet.getInstance(environment.integration_secretkey).then((fernet) => {
          fernet.decrypt(integration).then((res) => {
            resolve(atob(res));
          })
        })
      });
    };
  }

  encrypt(token: string): Promise<any> {
    if(token){
      return new Promise((resolve) => {
        Fernet.getInstance(environment.ENCRYPTION_SECRET_KEY).then((fernet) => {
          fernet.encrypt(token).then((res) => {
            resolve((res));
          })
        })
      })
    }
  }

  encryptpayload(token: string): Promise<any> {
    if(token){
      return new Promise((resolve)=>{
        Fernet.getInstance(environment.integration_secretkey).then((fernet)=>{
          fernet.encrypt(token).then((res)=>{
            resolve(res);
          })
        })
      })
    }
  }
  jwtToJson(token: string) {
    return JSON.parse(atob(token.split('.')[1]));
  }
  decrypt(token: string): Promise<any> {
    if(token){
      return new Promise((resolve) => {
        Fernet.getInstance(environment.ENCRYPTION_SECRET_KEY).then((fernet) => {
          fernet.decrypt(token).then((res) => {
            resolve(res);
          })
        })
      })
    }
  }

  addDropdownListeners(
    ionContent: any,
    onScrollCallback?: () => void,
    onClickCallback?: () => void
  ): void {
    this.initializeRenderer();
    if (!this.scrollDropdownListener) {
      this.scrollDropdownListener = this.renderer.listen(
        ionContent,
        'scroll',
        onScrollCallback
      );
    }

    if (!this.clickDropdownListener) {
      this.clickDropdownListener = this.renderer.listen(
        ionContent,
        'click',
        onClickCallback
      );
    }
  }

  removeDropdownListeners() {
    if (this.scrollDropdownListener) {
      this.scrollDropdownListener();
      this.scrollDropdownListener = null;
    }

    if (this.clickDropdownListener) {
      this.clickDropdownListener();
      this.clickDropdownListener = null;
    }
  }

  handleDropdownOpen(isOpen): void {
    if(isOpen){
      const overlayBackdrop = this.overlayContainer.getContainerElement().querySelector('.cdk-overlay-backdrop');
      const customPanel = this.overlayContainer.getContainerElement().querySelector('.custom-overlay-panel');
    
      if (overlayBackdrop && customPanel) {
        this.renderer.setStyle(overlayBackdrop, 'pointer-events', 'none');
      }
    } else {
      const overlayPane = this.overlayContainer.getContainerElement().querySelector('.cdk-overlay-pane');
      if (overlayPane) {
        this.renderer.removeStyle(overlayPane, 'visibility');
      }
      this.renderer = null;
    }  
  }

  handleDropdownCloseOnScroll(dropdown: MatSelect | MatAutocompleteTrigger): void {
    if (dropdown instanceof MatSelect) {
      if (dropdown.panelOpen) {
        dropdown.close();
      }
    }
    else if (dropdown instanceof MatAutocompleteTrigger) {
      if(dropdown.panelOpen){
        dropdown.closePanel();
        this.handleDropdownOpen(false);
      }
    }
    this.removeDropdownListeners();
  }

  handleDropdownCloseOnClick(dropdown: MatSelect | MatAutocompleteTrigger): void {
    const overlayPane = this.overlayContainer.getContainerElement().querySelector('.cdk-overlay-pane');
    const customPanel = this.overlayContainer.getContainerElement().querySelector('.custom-overlay-panel');
    
    if (overlayPane && customPanel) {
      this.renderer.setStyle(overlayPane, 'visibility', 'collapse');
    }
    this.handleDropdownCloseOnScroll(dropdown);  
  }
  

  indexNames:any;
  generateToken():Promise<any>{
    return new Promise<any>((resolve)=>{
      this.getStoragedetails().then((res) => {
        let payload = {
          type: 'index_management',
        };
        this.backendService
          .postApiTermsCall('getApiTerms', payload, res.token)
          .subscribe(
            (data) => {
              // this.helperService.loader()
              this.getGenerateRefreshToken(
                data['data'][0].username,
                data['data'][0].hashed_password
              ).then((r)=>{
                this.getindexdetails().then((names)=>{
                  resolve(names)
                })
              })
            },
            (error) => {
              //console.log(error);
              // this.helperService.closeLoader();
              // this.helperService.presentToast(error.error.detail, 2000);
            }
          );
      });
    })
  }
  async getStoragedetails() {
    let res = {
     id:await this.storage.get('id'),
     goldFinchGenerateAccessToken:await this.storage.get('goldFinchGenerateAccessToken'),
     token:await this.storage.get('token')
    }
    return res
   }

  getGenerateLatestAcessToken(access_token) {
    const payload = new FormData();
    payload.append('refresh_token', access_token);
    let python_base_url = environment.goldfinch_base_url + '/token';
    return new Promise((resolve) => {
      this.backendService
        .PostExternalTokenAPICall(python_base_url, payload)
        .subscribe(
          (data) => {
            resolve(data.access_token);
          },
          (error) => {
            //console.log(error);
          }
        );
    });
  }
  getGenerateRefreshToken(userName?, password?):Promise<any> {
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);
    let goldfinch_base_url = environment.goldfinch_base_url + '/refresh/token';
    return new Promise((resolve) => {
      this.backendService
        .PostExternalTokenAPICall(goldfinch_base_url, payload)
        .subscribe(
          (data) => {
            this.getGenerateLatestAcessToken(data.refresh_token).then(
              (access_token) => {
                //console.log("access_token", access_token);
                this.storage.set('goldFinchGenerateAccessToken', access_token);
                resolve(access_token)
              }
            );
          },
          (error) => {
            //console.log(error);
          }
        );
    });
  }
  getindexdetails(): Promise<any> {
    let dlNames
    return new Promise((resolve)=>{
      this.getStoragedetails().then((res) => {
        let python_base_url = environment.goldfinch_base_url + `/IndexManagement?action_type=get_user_indexes&filter_by=&user_id=${res.id}`;
        this.backendService.PostAPICallGoldFinch(python_base_url, {}, res.goldFinchGenerateAccessToken).subscribe((data)=>{
          dlNames=data.data.map((name)=>{
            return name.index_name.split('bizintel360-')[1]
          })
          resolve(dlNames)
        });
      });
    })
  }
  async handleError(error: any) {
    if (error?.error?.message) {
      return await this.presentToast(error.error.message, 2000);
    } else if (error?.error?.data) {
      return await this.presentToast(error.error.data, 2000);
    } else if (error?.error?.detail) {
      return await this.presentToast(error.error.detail, 2000);
    }    
  }

  triggerParentNavigationHelpFunction(data: any) {
    this.parentNavigationHelpTrigger.next(data);
  }

  triggerChildNavigationHelpFunction() {
    this.childNavigationHelpTrigger.next();
  }

  triggerSourcePostmanPreviewFunction(data: any) {
    this.sourcePostmanPreviewTrigger.next(data);
  }

  triggerTargetPostmanPreviewFunction(data: any) {
    this.targetPostmanPreviewTrigger.next(data);
  }
  
}